import { TableSchema } from '../metadata-schema';

export const dim_br_brin: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_br_brin",
	"description": "Definitie voor dimension tabel dim_br_brin uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Landelijk"
	],
	"properties": {
		"br_co_brin": {
			"type": "string",
			"label": "Vestigingscode",
			"searchKeys": [
				"BRIN",
				"BRIN (vestiging)"
			],
			"category": "School",
			"example": "01XX00"
		},
		"br_d_geldig_tot": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"br_d_geldig_va": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"br_is_vso": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"br_nm_brin_kort": {
			"type": "string",
			"label": "Vestiging (officieel)",
			"category": "School",
			"example": "Openb SGM CumLaude College"
		}
	}
};
